const body = document.body;
const hideRetailerPopup = () => {
    const buyNowPopup = document.querySelector('#buy-now-popup');
    body.classList.remove('retailer-pop-up');
    if (buyNowPopup) {
        buyNowPopup.classList.add('is-hiding');
        buyNowPopup.classList.remove('is-visible');
        setTimeout(() => {
            buyNowPopup.classList.remove('is-hiding');
        }, 400);
    }
};

document.addEventListener('product:added', function(event) {
    hideRetailerPopup();
});

document.addEventListener('DOMContentLoaded', function(event) {
    const radiosInputChecked = document.querySelector('.radios--input:checked');
    if (radiosInputChecked) {
        const variantId = radiosInputChecked.id
        const buyNowOption = document.querySelector(`.buy-now__option[for="${variantId}"]`)
        if (buyNowOption) {
            buyNowOption.classList.add('active');
        }
    }

    const buyNowButton = document.querySelectorAll('.buy-now-btn');
    buyNowButton.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.classList.add('retailer-pop-up');
            const buyNowPopup = document.querySelector('#buy-now-popup');
            buyNowPopup && buyNowPopup.classList.add('is-visible');

            const storerocketWidget = document.querySelector('#storerocket-widget');
            if (!storerocketWidget) {
                StoreRocket.init({
                    selector: ".storerocket-store-locator",
                    account: "OdJE6LL8WE"
                });
            }
        })
    })

    const buyNowClose = document.querySelectorAll('.buy-now__close');
    buyNowClose.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            hideRetailerPopup();
        })
    })


    const buyNowNavButton = document.querySelectorAll('.buy-now__nav-button');
    buyNowNavButton.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const target = e.target.dataset.target;
            const buyNowPanel = document.querySelector('.buy-now__panel')
            const buyNowTarget = document.querySelector(`.buy-now__${target}`);

            buyNowNavButton.forEach((b) => {
                b.classList.remove('buy-now__nav-button--active');
            })
            e.target.classList.add('buy-now__nav-button--active');

            buyNowPanel && buyNowPanel.classList.remove('buy-now__panel--active');
            buyNowTarget && buyNowTarget.classList.add('buy-now__panel--active');
        })
    })
});
